import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function OverlayTrigger(props = {}, childrenComponents = []) {
	return {
		componentName: 'OverlayTrigger',
		componentId: uuidv4(),
		props: _.merge(
			{
				trigger: 'click',
			},
			props,
		),
		childrenComponents,
	};
}
